/* Shopify asset: gem-konfiguration.js. Secrets must never be added here. */
(() => {
  'use strict';
  const fieldIds = [
    'extra-door-variant-select','extra-door-qty-select','extra-door-placement-comment',
    'auto-opluk-variant-select','auto-opluk-qty-select','ridge-decoration-variant-select',
    'montage-referral-variant-select','ophaengskroge-variant-select','ophaengskroge-qty-select',
    'foundation-accessory-variant-select','foundation-accessory-qty-select'
  ];
  const tick = () => new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
  const encode = value => {
    const bytes = new TextEncoder().encode(JSON.stringify(value));
    if (bytes.length > 9000) throw new Error('Konfigurationen er for stor til at gemme som link.');
    return btoa(Array.from(bytes, b => String.fromCharCode(b)).join('')).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
  };
  const decode = value => {
    if (value.length > 12000 || !/^[A-Za-z0-9_-]+$/.test(value)) throw new Error('Ugyldigt gemmelink.');
    const raw = atob(value.replace(/-/g,'+').replace(/_/g,'/'));
    return JSON.parse(new TextDecoder('utf-8', {fatal: true}).decode(Uint8Array.from(raw, c => c.charCodeAt(0))));
  };
  const cleanText = el => el?.textContent?.replace(/\s+/g,' ').trim() || '';
  // Mail labels come from option data, never presentation badges, prices or buttons.
  function cardLabel(card) {
    const labels = {
      'door-placement-card': 'Placering af dør', 'foundation-type-card': 'Fastgørelse til underlag',
      'extra-door-card': 'Ekstra dør', 'shelf-addon-card': 'Hylder', 'ophaengskroge-card': 'Ophængskroge',
      'auto-opluk-card': 'Automatisk vinduesåbner', 'ridge-decoration-card': 'Tagdekoration', 'montage-referral-card': 'Montering'
    };
    if (labels[card?.id]) return labels[card.id];
    if (card?.dataset.pv2OptionName) return card.dataset.pv2OptionName;
    if (card?.dataset.pv2Label) return card.dataset.pv2Label;
    const title = card?.querySelector('.pv2-option-card-title');
    if (!title) return 'Valg';
    if (typeof title.cloneNode === 'function') {
      const plain = title.cloneNode(true);
      plain.querySelectorAll('.pv2-guided-badge, .pv2-guided-price, button').forEach(node => node.remove());
      return cleanText(plain).replace(/^\d+\.\s*Vælg\s+/i, '') || 'Valg';
    }
    return cleanText(title).replace(/^\d+\.\s*Vælg\s+/i, '') || 'Valg';
  }
  function key(card) {
    if (card.id) return 'id:' + card.id;
    const option = card.querySelector('[data-option-index]');
    if (option) return 'option:' + option.dataset.optionIndex;
    return 'label:' + cleanText(card.querySelector('.pv2-option-card-title'));
  }
  function notice(message) {
    document.getElementById('pv2-restore-status')?.remove();
    const box = document.createElement('div');
    box.id = 'pv2-restore-status'; box.setAttribute('role', 'status');
    const close = document.createElement('button');
    close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label','Luk besked');
    close.addEventListener('click', () => box.remove());
    box.append(close, document.createTextNode(message)); document.body.append(box);
  }
  async function init() {
    if (window.pv2SaveInitialized) return;
    const settings = window.pv2SaveSettings;
    const overlay = document.getElementById('pv2-design-overlay');
    const modal = document.getElementById('pv2-summary-modal');
    const target = modal?.querySelector('.pv2-summary-btnwrap');
    if (!settings || !overlay || !target) {
      console.warn('Gem konfiguration: indstillinger eller modalens HTML mangler.');
      return;
    }
    window.pv2SaveInitialized = true;
    function getBridge() {
      const current = window.pv2ConfigurationBridge;
      if (!current || typeof current.refresh !== 'function' || typeof current.variant !== 'function') {
        throw new Error('Gem-funktionen mangler forbindelse til konfiguratoren. Kontrollér den opdaterede variant-picker.js og fejl i browserens Console.');
      }
      return current;
    }
    const bridge = {
      refresh: () => getBridge().refresh(),
      variant: () => getBridge().variant()
    };
    const cards = () => Array.from(overlay.querySelectorAll('.pv2-option-card'));
    let restoring = false;
    function snapshot() {
      bridge.refresh();
      const variant = bridge.variant();
      if (!variant) throw new Error('Vælg først produktets farve og øvrige varianter.');
      return {
        v: 1, path: settings.productPath, variant: String(variant.id),
        choices: cards().flatMap(card => {
          const selected = card.querySelector('.pv2-option-value-item.active');
          return selected ? [{key: key(card), value: selected.dataset.value, label: cardLabel(card)}] : [];
        }),
        fields: fieldIds.flatMap(id => {
          const el = document.getElementById(id);
          return el ? [{id, value: el.value}] : [];
        }),
        shelves: Array.from(overlay.querySelectorAll('.shelf-qty-input')).filter(el => Number(el.value) > 0).map(el => ({id: el.dataset.variant, quantity: Number(el.value)}))
      };
    }
    function link(config) {
      const url = new URL(settings.productPath, location.origin);
      url.searchParams.set('variant', config.variant);
      url.hash = 'pv2config=' + encode(config);
      return url.href;
    }
    function report(config) {
      // Plain text only. The Make email template escapes these values before HTML rendering.
      const lines = config.choices.map(c => `${c.label}: ${c.value === 'add' ? 'Ja' : c.value === 'none' ? 'Nej' : c.value}`);
      for (const f of config.fields) {
        const el = document.getElementById(f.id);
        const card = el?.closest('.pv2-option-card');
        const activeValue = card?.querySelector('.pv2-option-value-item.active')?.dataset.value;
        if (activeValue !== 'add' && activeValue !== 'skruer') continue;
        const label = cardLabel(card);
        if (el.tagName === 'SELECT') {
          lines.push(`${label} — ${f.id.includes('-qty-') ? 'Antal' : 'Variant'}: ${cleanText(el.selectedOptions[0])}`);
        } else if (f.value.trim()) lines.push(`Placering ekstra dør: ${f.value.trim()}`);
      }
      for (const s of config.shelves) {
        const input = Array.from(overlay.querySelectorAll('.shelf-qty-input')).find(el => el.dataset.variant === s.id);
        const product = input?.dataset.prod || cleanText(input?.closest('.shelf-addon-product')?.querySelector('.shelf-product-heading')) || 'Hylde';
        const variant = input?.dataset.title || '';
        lines.push(`${product}${variant ? ' — ' + variant : ''}: ${s.quantity} stk.`);
      }
      return lines;
    }
    let form = document.getElementById('pv2-save-form');
    if (!form) {
      form = document.createElement('form');
      form.id = 'pv2-save-form';
      form.innerHTML = "\n  <div id=\"pv2-save-fields\">\n    <span class=\"pv2-save-emblem\" aria-hidden=\"true\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"22\" viewBox=\"0 0 24 24\" fill=\"none\" aria-hidden=\"true\"><path d=\"M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z\" stroke=\"currentColor\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></span>\n    <h3 class=\"pv2-save-panel-title\">Dit design. Klar til senere.</h3>\n    <p class=\"pv2-save-panel-intro\">Få dit design og et personligt link på mail. Så kan du fortsætte, når det passer dig.</p>\n    <label for=\"pv2-save-email\">Din mailadresse</label>\n    <input id=\"pv2-save-email\" type=\"email\" autocomplete=\"email\" maxlength=\"254\" required placeholder=\"din@email.dk\">\n    <label class=\"pv2-save-honeypot\" aria-hidden=\"true\">Website<input id=\"pv2-save-website\" name=\"website\" type=\"text\" tabindex=\"-1\" autocomplete=\"off\"></label>\n    <button id=\"pv2-save-send\" type=\"submit\">Send mit design</button>\n    <p class=\"pv2-save-note\">Du kan åbne linket på både computer og mobil.</p>\n  </div>\n  <div id=\"pv2-save-success\" hidden role=\"status\" aria-live=\"polite\">\n    <span class=\"pv2-save-success-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26\" height=\"26\" viewBox=\"0 0 24 24\" fill=\"none\" aria-hidden=\"true\"><path d=\"m5 12 4 4L19 6\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg></span>\n    <h3 id=\"pv2-save-success-title\" tabindex=\"-1\">Dit design er sendt</h3>\n    <p>Vi har sendt dit design til<br><strong id=\"pv2-save-recipient\"></strong></p>\n    <p class=\"pv2-save-success-note\">Gem mailen, så du nemt kan finde dit design igen. Tjek også din spammappe.</p>\n    <button id=\"pv2-save-again\" type=\"button\">Brug en anden mailadresse</button>\n  </div>\n  <p id=\"pv2-save-status\" role=\"status\" aria-live=\"polite\"></p>\n  <div class=\"pv2-save-divider\"><span>eller</span></div>\n  <button id=\"pv2-save-copy\" type=\"button\">Kopiér link til dit design</button>\n";
    // Avoid nesting a form if the existing theme wraps the modal in a product form.
    if (target.closest('form')) {
      notice('Gem-funktionen skal placeres uden for produktformularen. Se opsætningsvejledningen.');
      return;
    }
      target.append(form);
    }
    const status = form.querySelector('#pv2-save-status');
    const send = form.querySelector('#pv2-save-send');
    const fields = form.querySelector('#pv2-save-fields');
    const success = form.querySelector('#pv2-save-success');
    const recipient = form.querySelector('#pv2-save-recipient');
    form.querySelector('#pv2-save-again')?.addEventListener('click', () => {
      if (fields) fields.hidden = false;
      if (success) success.hidden = true;
      form.dataset.state = '';
      status.textContent = '';
      form.querySelector('#pv2-save-email').focus?.();
    });
    const formStarted = Date.now();
    let lastSentAt = 0;
    let pendingSaveEvent = null;
    for (const id of ['pv2-summary-overview-btn','sticky-summary-overview-btn']) {
      const btn = document.getElementById(id);
      if (!btn) continue;
      btn.type = 'button'; btn.setAttribute('aria-label','Gem dit design');
      // Keep the compact icon on the sticky button.
      if (id === 'pv2-summary-overview-btn') btn.textContent = 'Gem dit design';
    }
    const heading = modal.querySelector('.pv2-summary-title');
    if (heading) heading.textContent = 'Gem dit design';
    form.querySelector('#pv2-save-copy').addEventListener('click', async () => {
      try {
        if (restoring) throw new Error('Vent, mens dine valg gendannes.');
        const url = link(snapshot());
        if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(url); status.textContent = 'Linket er kopieret.'; }
        else window.prompt('Kopiér linket til din konfiguration:', url);
      } catch (error) {status.textContent = error.message;}
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (send.disabled || restoring || !form.reportValidity()) return;
      send.disabled = true; send.textContent = 'Sender dit design…';
      status.textContent = ''; form.dataset.state = 'sending';
      try {
        if (!settings.endpoint || settings.endpoint.includes('DIT-') || !/^https:\/\/hook(?:\.[a-z0-9-]+)*\.make\.com\/[a-z0-9]+$/i.test(settings.endpoint)) throw new Error('Mailfunktionen er ikke færdigopsat endnu.');
        if (Date.now() - formStarted < 3000) throw new Error('Vent et øjeblik, og tryk igen.');
        if (lastSentAt && Date.now() - lastSentAt < 60000) throw new Error('Din mail er allerede sendt. Vent et minut, hvis du vil sende igen.');
        if (form.querySelector('#pv2-save-website').value) throw new Error('Formularen kunne ikke sendes.');
        const config = snapshot();
        const selectedVariant = bridge.variant();

const image = selectedVariant?.featured_image;
const imageSource =
  (typeof image === 'string' ? image : image?.src) ||
  selectedVariant?.featured_media?.preview_image?.src ||
  '';

const variantImageUrl = imageSource
  ? new URL(imageSource, window.location.origin).href
  : '';
        const email = form.querySelector('#pv2-save-email').value.trim();
        const fingerprint = JSON.stringify([email.toLowerCase(), config]);
        if (!pendingSaveEvent || pendingSaveEvent.fingerprint !== fingerprint) {
          pendingSaveEvent = {
            fingerprint,
            id: window.crypto?.randomUUID?.() || 'pv2-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2),
            time: new Date(Date.now()).toISOString()
          };
        }
        const payload = new URLSearchParams({
          email,
          product_title: settings.productTitle,
          product_path: config.path,
          variant_id: config.variant,
          variant_image_url: variantImageUrl,
          encoded_configuration: encode(config),
          save_event_id: pendingSaveEvent.id,
          saved_at: pendingSaveEvent.time,
          design_url: link(config),
          configuration_json: JSON.stringify(config),
          currency: window.Shopify?.currency?.active || 'DKK',
          summary: report(config).join('\n'),
          price: cleanText(document.getElementById('pv2-summary-total')),
          website: '',
          elapsed_ms: String(Date.now() - formStarted)
        });
        // URL-encoded form data works with Make and does not trigger CORS preflight.
        const response = await fetch(settings.endpoint, {
          method: 'POST', body: payload, signal: AbortSignal.timeout(35000)
        });
        let result;
        try { result = await response.json(); }
        catch { throw new Error('Afsendelsen kunne ikke bekræftes. Tjek din mail, før du prøver igen.'); }
        if (!response.ok || result.ok !== true) throw new Error(result.message || 'Mailen kunne ikke sendes.');
        lastSentAt = Date.now();
        pendingSaveEvent = null;
        if (recipient) recipient.textContent = payload.get('email');
        if (fields) fields.hidden = true;
        if (success) success.hidden = false;
        form.dataset.state = 'success';
        status.textContent = success ? '' : 'Dit design er sendt. Tjek også din spammappe.';
        form.querySelector('#pv2-save-success-title')?.focus?.();
      } catch (error) {
        form.dataset.state = 'error';
        status.textContent = error.name === 'TimeoutError' ? 'Afsendelsen tog for lang tid. Tjek din mail, før du prøver igen.' : error.message;
      } finally {
        send.disabled = false; send.textContent = 'Send mit design';
      }
    });
    async function restore(encoded) {
      restoring = true;
      try {
        const config = decode(encoded);
        if (config.v !== 1 || config.path !== settings.productPath || !Array.isArray(config.choices) || config.choices.length > 20 || !Array.isArray(config.fields) || config.fields.length > 20 || !Array.isArray(config.shelves) || config.shelves.length > 40) throw new Error('Linket passer ikke til dette produkt.');
        const variant = window.pv2Variants?.find(v => String(v.id) === config.variant);
        if (!variant || !variant.available) throw new Error('Den gemte produktvariant er udsolgt eller udgået. Vælg en ny konfiguration.');
        const selected = config.choices.map(choice => {
          const card = cards().find(c => key(c) === choice.key);
          const item = card && Array.from(card.querySelectorAll('.pv2-option-value-item')).find(el => el.dataset.value === choice.value);
          if (!item || item.disabled || item.getAttribute('aria-disabled') === 'true') throw new Error('Et gemt valg findes ikke længere. Konfigurationen blev ikke gendannet; vælg dine valg på ny.');
          return item;
        });
        const fields = config.fields.map(f => {
          if (!fieldIds.includes(f.id) || typeof f.value !== 'string' || f.value.length > 1000) throw new Error('Ugyldigt gemmelink.');
          const el = document.getElementById(f.id);
          if (!el || (el.tagName === 'SELECT' && !Array.from(el.options).some(o => o.value === f.value && !o.disabled))) throw new Error('Et gemt tilbehørsvalg findes ikke længere. Konfigurationen blev ikke gendannet.');
          return [el, f.value];
        });
        const shelves = config.shelves.map(s => {
          const input = Array.from(overlay.querySelectorAll('.shelf-qty-input')).find(el => el.dataset.variant === s.id);
          if (!input || !Number.isInteger(s.quantity) || s.quantity < 1 || s.quantity > 6) throw new Error('En gemt hylde findes ikke længere. Konfigurationen blev ikke gendannet.');
          return [input, s.quantity];
        });
        // Preflight the main variant before touching any controls.
        const optionChoices = selected.filter(el => el.hasAttribute('data-option-index'));
        const options = variant.options || [variant.option1,variant.option2,variant.option3].filter(Boolean);
        if (optionChoices.length && !optionChoices.every(el => options[Number(el.dataset.optionIndex)] === el.dataset.value)) throw new Error('Produktets varianter er ændret. Vælg en ny konfiguration.');
        for (const item of selected) { item.click(); await tick(); }
        for (const [el, value] of fields) {
          el.value = value; el.dispatchEvent(new Event('input', {bubbles: true})); el.dispatchEvent(new Event('change', {bubbles: true}));
        }
        overlay.querySelectorAll('.shelf-qty-input').forEach(input => {input.value = '0';});
        for (const [input, quantity] of shelves) {
          input.value = String(quantity);
          const product = input.closest('.shelf-addon-product');
          const dropdown = product?.querySelector('.shelf-variant-dropdown');
          if (dropdown) {dropdown.value = input.dataset.variant; dropdown.dispatchEvent(new Event('change', {bubbles: true}));}
        }
        bridge.refresh(); await tick(); bridge.refresh();
        if (String(bridge.variant()?.id) !== config.variant) throw new Error('Kontrollér dine valg. Produktets variant kunne ikke gendannes korrekt.');
        document.getElementById('openDesignerBtn')?.click();
        notice('Dine valg er gendannet. Kontrollér konfigurationen og den aktuelle pris, inden du køber.');
      } catch (error) {notice(error.message || 'Konfigurationen kunne ikke åbnes.');}
      finally {restoring = false;}
    }
    // Capture before the existing variant picker rewrites URL parameters.
    const saved = window.pv2InitialSavedConfiguration;
    if (saved) await restore(saved);
    window.addEventListener('hashchange', () => {
      const match = location.hash.match(/^#pv2config=([A-Za-z0-9_-]+)$/);
      if (match && !restoring) restore(match[1]);
    });
  }
  window.pv2InitialSavedConfiguration = location.hash.match(/^#pv2config=([A-Za-z0-9_-]+)$/)?.[1] || null;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => {init();}, {once: true});
  else init();
})();
